"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatShortName = exports.formatPlayerUnknown = exports.formatPlayerNames = exports.formatLastName = exports.formatFullName = exports.formatFirstName = exports.formatAbbr = void 0;

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: slobasd23
 */
var tracerRegex = /Tracer(\s+?-?\d+?)?/gi;

var formatPlayerNames = function formatPlayerNames(player) {
  var _player$user, _player$user2;

  var firstName = '';
  var lastName = '';
  var isTracer = false;

  if (player.first_name) {
    firstName = player.first_name;
  } else if ((_player$user = player.user) !== null && _player$user !== void 0 && _player$user.first_name) {
    firstName = player.user.first_name;
  }

  if (player.last_name) {
    lastName = player.last_name;
  } else if ((_player$user2 = player.user) !== null && _player$user2 !== void 0 && _player$user2.last_name) {
    lastName = player.user.last_name;
  }

  if (firstName.match(tracerRegex)) {
    isTracer = true;

    if (player.trace_number) {
      firstName = "Tracer ".concat(player.trace_number);
    } else if (player.id) {
      firstName = "Tracer ".concat(player.id);
    } else if (player.default_trace_number) {
      firstName = "Tracer ".concat(player.default_trace_number);
    }
  }

  return {
    firstName: firstName,
    lastName: lastName,
    isTracer: isTracer
  };
};
/**
 * formatFullName
 * @params {Player} player, a player object to format full name from
 * @return {string} the player's full name
 */


exports.formatPlayerNames = formatPlayerNames;

var formatFullName = function formatFullName(player) {
  var formattedPlayer = formatPlayerNames(player);
  var name = formattedPlayer.firstName + ' ' + formattedPlayer.lastName;
  return name.trim();
};
/**
 * formatShortName
 * @params {player}, a player object to format first name from
 * @return {string} the player's first name
 */


exports.formatFullName = formatFullName;

var formatShortName = function formatShortName(player) {
  var formattedPlayer = formatPlayerNames(player);
  var name = formattedPlayer.firstName ? formattedPlayer.firstName.substring(0, 1) + '.' : '';
  name += ' ';
  name += formattedPlayer.lastName;
  return name.trim();
};
/**
 * formatFirstName
 * @params {player}, a player object to format first name from
 * @return {string} the player's first name
 */


exports.formatShortName = formatShortName;

var formatFirstName = function formatFirstName(player) {
  var formattedPlayer = formatPlayerNames(player);
  return formattedPlayer.firstName.trim();
};
/**
 * formatLastName
 * @params {player}, a player object to format last name from
 * @return {string} the player's last name
 */


exports.formatFirstName = formatFirstName;

var formatLastName = function formatLastName(player) {
  var formattedPlayer = formatPlayerNames(player);
  var lastName = !formattedPlayer.isTracer ? formattedPlayer.lastName : '';
  return lastName.trim();
};
/**
 * formatAbbr
 * @params {player}, a player object to format abbr from
 * @return {string} the player's abbr
 */


exports.formatLastName = formatLastName;

var formatAbbr = function formatAbbr(player) {
  var _player$user3;

  var formattedPlayer = formatPlayerNames(player);
  var abbr = ''; // Abbr

  if (player.abbr) {
    abbr = player.abbr;
  } else if ((_player$user3 = player.user) !== null && _player$user3 !== void 0 && _player$user3.abbr) {
    abbr = player.user.abbr;
  } // generate abbr


  if (abbr.length === 0) {
    if (formattedPlayer.firstName) {
      abbr += formattedPlayer.firstName[0];
    }

    if (formattedPlayer.lastName) {
      abbr += formattedPlayer.lastName[0];
    }
  } // tracer user


  if (formattedPlayer.isTracer) {
    if (player.trace_number) {
      abbr = "".concat(player.trace_number.length < 2 ? '0' : '').concat(player.trace_number);
    } else if (player.id) {
      abbr = "".concat(player.id.length < 2 ? '0' : '').concat(player.id);
    }
  }

  return abbr;
};
/**
 * formatPlayerUnknown
 * @params {player}, a player object to format abbr from
 * @return {boolean} true if this is a known player, false if this player is unkown/default tracer user
 */


exports.formatAbbr = formatAbbr;

var formatPlayerUnknown = function formatPlayerUnknown(player) {
  var _player$user4;

  var firstName = '';

  if (player !== null && player !== void 0 && player.first_name) {
    firstName = player.first_name;
  } else if (player !== null && player !== void 0 && (_player$user4 = player.user) !== null && _player$user4 !== void 0 && _player$user4.first_name) {
    firstName = player.user.first_name;
  } // Trace user


  return !!firstName.match(tracerRegex);
};

exports.formatPlayerUnknown = formatPlayerUnknown;